import { React, useState, useEffect } from 'react';
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import ApiService from "./ApiService";
import { useNavigate } from 'react-router-dom';
import loading from '../assetss/img/loading64.gif'


function SurveyPage() {
    const [pageMessage, setPageMessage] = useState("Buscando...");
    const [Loading, setLoading] = useState(false);
    const [pcodigo, setPcodigo] = useState(null);
    const [pturnoid, setPturnoid] = useState(null);
    const [showPage, setShowPage] = useState(false);


    //const navigate = useNavigate();
    //const GoToHomePage = () => navigate('/home');


    useEffect(() => {
        buscarParametros();
    }, []);

    function buscarParametros() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const turnoid = urlParams.get('ti')
        const codigo = urlParams.get('co')
        if (turnoid === null || codigo === null) {
            window.location.replace("http://www.consulmed.com.ar");
        } else {
            setPcodigo(codigo);
            setPturnoid(turnoid);
            setShowPage(true);
            comprobarRespuesta(codigo, turnoid);
        }
    }

    async function comprobarRespuesta(Codigo, TurnoId) {
        setLoading(true);
        let params = "co=" + Codigo + "&ti=" + TurnoId;
        let result = await ApiService.GetEncuesta("encuesta-respuesta/comprobar", params);
        if (result.error === true) {
            setLoading(false);
            setPageMessage(result.errormessage);
        } else {
            setLoading(false);
            setPageMessage("");
        }
        return;
    }


    return (
        <>
            <div>
                {showPage &&
                    <>
                        <Header />
                        {
                            (Loading) &&
                            <div className='flex justify-center mt-2'>{(Loading) && <img alt="Loading" src={loading} />}</div>
                        }
                        {pageMessage === "" &&
                            <Body setPageMessage={setPageMessage} codigo={pcodigo} turno_id={pturnoid} />
                        }
                        {(pageMessage !== "" && Loading === false) &&
                            <div className="flex justify-center">
                                <div className="mt-5 mb-5 ml-5" >
                                    <h1 className="text-2xl md:text-3xl  text-slate-500   font-overpass font-medium">
                                        {pageMessage}
                                    </h1>
                                </div>
                            </div>
                        }
                        <Footer />
                    </>
                }
            </div>
        </>
    )
}

export default SurveyPage;
